import './ModalCodigoQR.scss';
import { PropTypes, number } from 'prop-types';
import { QRCode, Button, Modal, Row, Col, Form } from 'antd';
import QR from 'assets/images/logo_simac_qr.png';
import code from 'assets/images/Imagen_Mensajes.svg';
import { DownloadOutlined } from '@ant-design/icons';

const monitoringModel = {
  folio: '',
  idMonitoreo: number,
  idEstado: number,
  codigoMonitoreo: '',
  idProcesoGeneral: number,
  descProcesoGral: '',
  idTipoEleccion: number,
  idAmbito: number,
  idTipoMonitoreo: number,
  estatus: number,
  estatusSincronizado: 1,
  tipoRegistro: 1, // porque móvil realizará el registro de hallazgos
  fechaRegistro: number,
  usuario: '',
  tipoVisita: null
};

let idActa;

const ModalCodigoQR = ({ open, onClose, crearActaCierre, dataQr, callback }) => {
  const [form] = Form.useForm();
  if (dataQr) {
    if (Object.keys(dataQr).length > 0) {
      const dataActaQR = dataQr.actas.find((e) => e.idTipoActa === 1);
      idActa = dataActaQR?.idActa;
      monitoringModel.folio = dataQr.folio;
      monitoringModel.idMonitoreo = dataQr.idMonitoreo;
      monitoringModel.idEstado = dataQr.idEstado;
      monitoringModel.idProcesoGeneral = dataQr.idProcesoGral;
      monitoringModel.descProcesoGral = dataQr.descripcionProcesoGral;
      monitoringModel.idTipoEleccion = dataQr.idTipoEleccion;
      monitoringModel.idAmbito = dataQr.idAmbito;
      monitoringModel.idTipoMonitoreo = dataQr.idTipoMonitoreo;
      monitoringModel.estatus = dataQr.estatusMonitoreo;
      monitoringModel.fechaRegistro = dataQr.fechaRegistro;
      monitoringModel.usuario = dataQr.usuarioRegistro;
      monitoringModel.tipoRegistro = dataQr.tipoRegistro;
      monitoringModel.codigoMonitoreo = `${dataQr.usuarioRegistro}_${dataQr.fechaRegistro}_${dataQr.tipoRegistro}_${dataQr.idTipoMonitoreo}`;
    }
  }

  const handleCancel = () => {
    onClose(false);
    callback(false);
  };

  const handleCierre = async () => {
    crearActaCierre({ dataActaCierre: { ...dataQr } });
    handleCancel();
  };

  const handleDownload = () => {
    const canvas = document.getElementById('qr-canvas')?.querySelector('canvas');
    if (canvas) {
      const url = canvas.toDataURL();
      const a = document.createElement('a');
      a.download = `QR-SIMAC-1-${monitoringModel.idMonitoreo}.png`;
      a.href = url;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    }
  };

  const renderAcccions = () => {
    if (dataQr?.idActaCierre !== undefined) {
      return (
        <div>
          <Row>
            <Col span={5} />
            <Col span={19}>
              <span style={{ fontWeight: 'bold', color: '#A4A2A2', fontSize: '20px' }}>&nbsp;</span>
              <span style={{ color: '#C6C6C6', fontSize: '20px' }}>&nbsp;</span>
            </Col>
          </Row>
          <Row>
            <Col span={9} />
            <img src={code} alt="" style={{ width: 200, height: 200 }} />
          </Row>
          <Row style={{ width: '100%' }}>
            <Col span={5} />
            <Col span={19}>
              <span style={{ fontSize: '19px' }}>El acta de cierre se guardó con éxito.</span>
            </Col>
          </Row>
          <Row>
            <Col span={5} />
            <Col span={19}>
              <span style={{ fontWeight: 'bold', color: '#A4A2A2', fontSize: '20px' }}>
                ID acta:
              </span>
              <span
                style={{ color: '#C6C6C6', fontSize: '20px' }}>{`  ${dataQr?.idActaCierre}`}</span>
            </Col>
          </Row>
          <Row>
            <Col span={5} />
            <Col span={19}>
              <span style={{ fontWeight: 'bold', color: '#A4A2A2', fontSize: '20px' }}>
                Folio de monitoreo:
              </span>
              <span style={{ color: '#C6C6C6', fontSize: '20px' }}>{`  ${dataQr?.folio}`}</span>
            </Col>
          </Row>
          <Row>
            <Col span={5} />
            <Col span={19}>
              <span style={{ fontWeight: 'bold', color: '#A4A2A2', fontSize: '20px' }}>&nbsp;</span>
              <span style={{ color: '#C6C6C6', fontSize: '20px' }}>&nbsp;</span>
            </Col>
          </Row>
        </div>
      );
    }
    return (
      <div>
        <div
          id="qr-canvas"
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            padding: '20px'
          }}>
          <Row>
            <QRCode
              value={`
              {"folio": "${monitoringModel.folio}",
                "idMonitoreo": ${monitoringModel.idMonitoreo},
                "idEstado": ${monitoringModel.idEstado},
                "codigoMonitoreo": "${monitoringModel.codigoMonitoreo}",
                "idProcesoGeneral": ${monitoringModel.idProcesoGeneral},
                "descProcesoGral": "${monitoringModel.descProcesoGral}",
                "idTipoEleccion": ${monitoringModel.idTipoEleccion},
                "idAmbito": ${monitoringModel.idAmbito},
                "idTipoMonitoreo": 1,
                "estatus": ${monitoringModel.estatus},
                "estatusSincronizado": ${monitoringModel.estatusSincronizado},
                "tipoRegistro": ${monitoringModel.tipoRegistro},
                "fechaRegistro": "${monitoringModel.fechaRegistro}",
                "usuario": "${monitoringModel.usuario}"}`}
              size={320}
              errorLevel="L"
              color="#D5157E"
              icon={QR}
            />
          </Row>
        </div>
        <Row>
          <Col span={9} />
          <Col span={14}>
            <span style={{ fontWeight: 'bold', color: '#A4A2A2', fontSize: '18px' }}>ID acta:</span>
            <span style={{ color: '#C6C6C6', fontSize: '22px' }}>{`  ${idActa}`}</span>
          </Col>
        </Row>
        <Row>
          <Col span={6} />
          <Col span={16}>
            <span style={{ fontWeight: 'bold', color: '#A4A2A2', fontSize: '18px' }}>
              Folio de monitoreo:
            </span>
            <span style={{ color: '#C6C6C6', fontSize: '22px' }}>{`  ${dataQr?.folio}`}</span>
          </Col>
        </Row>
        {monitoringModel.tipoRegistro === 2 && monitoringModel.estatus === 1 && (
          <Row style={{ width: '100%' }} className="margenbooton">
            <Col span={8} />
            <Col span={12}>
              <Form.Item>
                {/* <Button htmlType="submit" text="Generar acta de cierre" onClick={handleCierre}>
                  Generar acta de cierre
                </Button> */}
                <Button type="primary" style={{ marginTop: '10px' }} onClick={handleCierre}>
                  Generar acta de cierre
                </Button>
              </Form.Item>
            </Col>
          </Row>
        )}
        <Row>
          <Col span={9} />
          <Col span={12}>
            <Button type="primary" style={{ marginTop: '10px' }} onClick={handleDownload}>
              <DownloadOutlined /> Descargar
            </Button>
          </Col>
        </Row>
      </div>
    );
  };

  return (
    <Modal footer={null} width="37%" open={open} onCancel={handleCancel} centered>
      <Form name="form-QR" layout="vertical" form={form}>
        {renderAcccions()}
      </Form>
    </Modal>
  );
};

export default ModalCodigoQR;

ModalCodigoQR.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func,
  crearActaCierre: PropTypes.func.isRequired,
  callback: PropTypes.func.isRequired,
  dataQr: PropTypes.shape({
    idActaCierre: PropTypes.number,
    id: PropTypes.number,
    codigoMonitoreo: PropTypes.string,
    folio: PropTypes.string,
    idMonitoreo: PropTypes.number,
    idEstado: PropTypes.number,
    idProcesoGral: PropTypes.number,
    descripcionProcesoGral: PropTypes.string,
    idTipoEleccion: PropTypes.number,
    idAmbito: PropTypes.number,
    idTipoMonitoreo: PropTypes.number,
    estatusMonitoreo: PropTypes.number,
    fechaRegistro: PropTypes.string,
    userName: PropTypes.string,
    estatusMonitoreoId: PropTypes.number,
    tipoRegistro: PropTypes.number,
    fechaApertura: PropTypes.string,
    usuarioRegistro: PropTypes.string,
    actas: PropTypes.arrayOf(
      PropTypes.shape({
        idActa: PropTypes.number,
        idTipoActa: PropTypes.number
      })
    )
  })
};

ModalCodigoQR.defaultProps = {
  onClose: () => {},
  dataQr: {}
};
